import { IDataProvider } from './IDataProvider';
import { IAuthProvider } from './IAuthProvider';

export type BuildTarget = 'spfx' | 'standalone';

declare const __BUILD_TARGET__: BuildTarget | undefined;

export function getBuildTarget(): BuildTarget {
  if (typeof __BUILD_TARGET__ !== 'undefined') return __BUILD_TARGET__;
  return 'standalone';
}

export interface IProvidersBundle {
  data: IDataProvider;
  auth: IAuthProvider;
}

/**
 * Standalone factory — used by the standalone entry point.
 * Imports REST/JWT providers only so the bundle stays free of mock data.
 */
export function createStandaloneProviders(apiBaseUrl: string = '/api'): IProvidersBundle {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { RestDataProvider } = require('./RestDataProvider');
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { JwtAuthProvider } = require('./JwtAuthProvider');
  return {
    data: new RestDataProvider(apiBaseUrl),
    auth: new JwtAuthProvider(apiBaseUrl),
  };
}

export function createMockProviders(): IProvidersBundle {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { MockDataProvider } = require('./MockDataProvider');
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { MockAuthProvider } = require('./MockAuthProvider');
  return {
    data: new MockDataProvider(),
    auth: new MockAuthProvider(),
  };
}
